import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik, Field,  ErrorMessage } from 'formik';

import { userActions } from '../_actions';
// import { Button, Form } from 'semantic-ui-react';
// import 'semantic-ui-css/semantic.min.css';
import validate from './validation/validate-yup';
import getValidationSchema from './validation/getValidationSchema-yup';

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        firstName: '',
        lastName: '',
        email: '',
        companyCode: '',
        userId: '',
        password: ''
      },
      submitted: false
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value
      }
    });
  };

  handleSubmit = (data, setSubmitting) => {
    // const { user } = this.state;
    const { dispatch } = this.props;
    // if (user.firstName && user.lastName && user.companyCode && user.email && user.userId && user.password) {
    //     dispatch(userActions.register(user));
    // }

    dispatch(userActions.register(data));
  };

  render() {
    const { registering } = this.props;

    const initialValues = {
      firstName: '',
      lastName: '',
      email: '',
      companyCode: '',
      userId: '',
      password: ''
    };

    return (
      <Formik
        initialValues={initialValues}
        validate={validate(getValidationSchema)}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            this.handleSubmit(values, setSubmitting);
          }, 400);
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <div className="col-md-6 col-md-offset-3">
            <h2>Register</h2>
            <form name="form" onSubmit={handleSubmit}>
              <div className={'form-group'}>
                <Field
                  placeholder="First Name"
                  type="text"
                  id="firstName"
                  name="firstName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.firstName}
                />
                <div className="errorMsg">
                  <ErrorMessage name="firstName" />
                </div>
              </div>
              <div className={'form-group'}>
                <Field
                  placeholder="Last Name"
                  type="text"
                  id="lastName"
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                />
                <div className="errorMsg">
                  <ErrorMessage name="lastName" />
                </div>
              </div>
              <div className={'form-group'}>
                <Field
                  name="email"
                  type="email"
                  id="email"
                  placeholder="E-mail address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                />
                <div className="errorMsg">
                  <ErrorMessage name="email" />
                </div>
              </div>
              <div className={'form-group'}>
                <label htmlFor="companyCode">Company Code</label>
                <Field
                  name="companyCode"
                  id="companyCode"
                  type="text"
                  placeholder="Company Code"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.companyCode}
                />
                <div className="errorMsg">
                  <ErrorMessage name="companyCode" />
                </div>
              </div>
              <div className={'form-group'}>
                <label htmlFor="userId">User Id</label>
                <Field
                  name="userId"
                  id="userId"
                  type="text"
                  placeholder="User ID"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.userId}
                />
                <div className="errorMsg">
                  <ErrorMessage name="userId" />
                </div>
              </div>
              <div className={'form-group'}>
                <label htmlFor="password">Password</label>
                <Field
                  placeholder="Password"
                  type="password"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                <div className="errorMsg">
                  <ErrorMessage name="password" />
                </div>
              </div>
              <div className="form-group">
                {/* <Button type="submit" color="black" fluid size="large">
                  Register
                </Button> */}

                <button type="submit" className="btn btn-primary ">
                  Register
                </button>

                {registering && (
                  <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                )}
                <Link to="/signin" className="btn btn-link">
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  const { registering } = state.registration;
  return {
    registering
  };
}

const connectedRegisterPage = connect(mapStateToProps)(RegisterPage);
export { connectedRegisterPage as RegisterPage };
